import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { LiveNavigationConfig } from '@frontend/sports/common/client-config-data-access';

import { RedirectHelperService } from '../navigation-core/redirect-helper.service';
import { UrlHelperService } from '../navigation-core/url-helper.service';
import { LiveEventsNavigationService } from './live-events-navigation/live-events-navigation.service';

@Injectable({ providedIn: 'root' })
export class EventDetailsGuard {
    constructor(
        private redirectHelperService: RedirectHelperService,
        private urlHelperService: UrlHelperService,
        private eventsNavService: LiveEventsNavigationService,
        private liveNavConfig: LiveNavigationConfig,
        private router: Router,
    ) {}

    async canActivate(): Promise<boolean | UrlTree> {
        if (!this.liveNavConfig.isLiveEventsNavigationEnabled) {
            this.redirectHelperService.goHome();
        }

        const defaultEvent = await this.eventsNavService.initFromDefaultEvent();

        if (defaultEvent) {
            const eventUrl = this.urlHelperService.getEventUrl(defaultEvent);

            return this.router.parseUrl(eventUrl);
        }

        return false;
    }
}
